import { useCurrentModule } from '../components/ModuleProvider';
import { extractNumericRate } from '../utils/extractNumericRate';
import { STUDIO_CURRENT_PLAN_BG_COLOR, STUDIO_CURRENT_PLAN_HAT_BG_COLOR, STUDIO_HIGHLIGHT_BG_COLOR, STUDIO_RECOMMENDED_BG_COLOR, STUDIO_SALE_BG_COLOR } from '../utils/consts';
import { useIsSeasonalSale } from './useIsSeasonalSale';
import { useIsStudioNewUi } from './useIsStudioNewUi';
export const useProductHat = _ref => {
  var _discountData$discoun;
  let {
    productId
  } = _ref;
  const module = useCurrentModule();
  const {
    data: product
  } = module.SDK.studioOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const {
    t
  } = module.internals.useTranslations();
  const {
    recommendedDisplayText,
    isRecommended,
    hasSale
  } = product ?? {};
  const {
    data: {
      isCurrentProduct
    } = {
      isCurrentProduct: false
    }
  } = module.SDK.switchApiClient.hooks.useIsCurrentProduct({
    productId
  });
  const isSeasonalSale = useIsSeasonalSale();
  const isStudioNewUi = useIsStudioNewUi();
  const {
    data: discountData
  } = module.SDK.studioOfferingApiClient.hooks.useFetchOfferingDiscount({});
  if (isCurrentProduct) {
    return {
      text: isStudioNewUi ? t('premium-purchase-plan.eclipse.cards.hat.current.plan') : t('premium-purchase-plan.cards.hat.current_plan'),
      background: isStudioNewUi ? STUDIO_CURRENT_PLAN_HAT_BG_COLOR : STUDIO_CURRENT_PLAN_BG_COLOR,
      hasHat: true,
      isRecommendedHat: false,
      isCurrentPlanHat: true
    };
  }
  if (isSeasonalSale && hasSale && discountData != null && (_discountData$discoun = discountData.discount) != null && _discountData$discoun.rate) {
    const numericRate = extractNumericRate(discountData.discount.rate);
    return {
      // Reuse the Eclipse coupon-label key so the hat text stays in sync
      // with the checkout coupon label (both render "{percent}% OFF").
      text: t('sale.product.x_off', {
        percent: numericRate
      }),
      background: STUDIO_SALE_BG_COLOR,
      hasHat: true,
      isRecommendedHat: false,
      isCurrentPlanHat: false
    };
  }
  if (isRecommended) {
    return {
      text: isStudioNewUi ? recommendedDisplayText : recommendedDisplayText == null ? void 0 : recommendedDisplayText.toUpperCase(),
      background: isStudioNewUi ? STUDIO_HIGHLIGHT_BG_COLOR : STUDIO_RECOMMENDED_BG_COLOR,
      hasHat: true,
      isRecommendedHat: true,
      isCurrentPlanHat: false
    };
  }
  return {
    text: undefined,
    background: undefined,
    hasHat: false,
    isRecommendedHat: false,
    isCurrentPlanHat: false
  };
};
//# sourceMappingURL=useProductHat.js.map